import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { alpha } from "@mui/material/styles";
import { LoadingButtonProps } from "types";

const LoadingButton = ({
  loading = false,
  disabled = false,
  children,
  className,
  sx,
  ...props
}: LoadingButtonProps) => {
  const isDisabled = loading || disabled;

  return (
    <Button
      {...props}
      disabled={isDisabled}
      aria-busy={loading}
      variant="contained"
      className={["login-config-button", className].filter(Boolean).join(" ")}
      sx={[
        (theme) => ({
          position: "relative",
          gap: 1.5,
          borderRadius: "9999px",
          textTransform: "none",
          transition: "all 200ms ease",
          cursor: isDisabled ? "not-allowed" : loading ? "wait" : "pointer",
          "&.Mui-focusVisible": {
            boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.6)}`,
          },
          "&.Mui-disabled": {
            backgroundColor: alpha(theme.palette.primary.main, 0.6),
            color: theme.palette.primary.contrastText,
          },
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {loading && (
        <CircularProgress
          aria-hidden="true"
          size={20}
          thickness={5}
          color="inherit"
          sx={{
            position: "absolute",
            left: "50%",
            marginLeft: "-10px",
          }}
        />
      )}
      <Box component="span" sx={{ transition: "opacity 150ms ease", opacity: loading ? 0 : 1 }}>
        {children}
      </Box>
    </Button>
  );
};

export default LoadingButton;
